import { render, staticRenderFns } from "./ad-1200-112.vue?vue&type=template&id=2b98ba53"
import script from "./ad-1200-112.vue?vue&type=script&lang=js"
export * from "./ad-1200-112.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports